export default __webpack_public_path__ + "static/media/AuditRole.cbb5c100.png";